import { ApiBase } from '../api.js';
import { marketplaceData } from '../types/api/marketplace.js';

export class ApiMarketplaces extends ApiBase {
	async create(data: unknown): Promise<unknown> {
		const result = await this.api.post('/marketplaces', data);
		return result.data;
	}

	async read(data): Promise<unknown> {
		const result = await this.api.get('/marketplaces/active', {
			params: {
				...data
			}
		});
		return result.data;
	}

	async update(data: unknown): Promise<unknown> {
		const result = await this.api.put('/marketplaces', data);
		return result.data;
	}

	async delete(data: unknown): Promise<unknown> {
		const result = await this.api.delete('/marketplaces', data);
		return result.data;
	}

	async findByPage(data: { page?: number; size?: number; search?: string }): Promise<unknown> {
		const params = {
			page: data.page ? Number(data.page) : undefined,
			size: data.size ? Number(data.size) : undefined,
			search: data.search
		};

		const result = await this.api.get('/marketplaces', {
			params
		});
		return result.data;
	}

	async isValidUrls(data: { urls: string[]; type: string }): Promise<marketplaceData> {
		const result = await this.api.post('/marketplaces/marketplace-url', data);
		return result.data;
	}

	async all(): Promise<unknown> {
		const result = await this.api.get('/marketplaces/all');
		return result.data;
	}

	async updateJurisdictions(id: string, jurisdictions: string[]): Promise<unknown> {
		const result = await this.api.put(`/marketplaces/jurisdictions/${id}`, { jurisdictions });
		return result.data;
	}

	async bulkAddJurisdictions(ids: string[], jurisdictions: string[]): Promise<unknown> {
		const result = await this.api.put(`/marketplaces/jurisdictions/bulk-add`, {
			ids,
			jurisdictions
		});
		return result.data;
	}
}
